document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    if (!event.target.matches('.footer-mobile-toggle')) return;
    event.target.classList.toggle('opened');
    event.target.classList.contains("opened") ? event.target.ariaExpanded = "true" : event.target.ariaExpanded = "false";
  });
});